import { render, staticRenderFns } from "./GasRatioC2h2C2h4Ch4H2.vue?vue&type=template&id=0bf6009f&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports